import { User, UserType } from "../types";
import { userHasPermission } from "../types-helpers";

type UserPermissionTarget = Pick<User, "userType" | "adminIds"> | null | undefined;

export const canManageUsersPage = (
  user: UserPermissionTarget,
): boolean => {
  if (!user || user.userType === UserType.Blocked) {
    return false;
  }

  return userHasPermission(UserType.User, user);
};

export const canViewRestrictedUsers = (
  user: UserPermissionTarget,
): boolean => {
  if (!user || user.userType === UserType.Blocked) {
    return false;
  }

  return userHasPermission(UserType.SysAdmin, user);
};

export const canInviteUsers = (
  user: UserPermissionTarget,
): boolean => {
  if (!user || user.userType === UserType.Blocked) {
    return false;
  }

  return userHasPermission(UserType.SysAdmin, user);
};

export const canManageTeamRole = (
  user: UserPermissionTarget,
  teamId?: string,
): boolean => {
  if (!user || user.userType === UserType.Blocked) {
    return false;
  }

  if (userHasPermission(UserType.SysAdmin, user)) {
    return true;
  }

  if (!teamId) {
    return false;
  }

  return Boolean(user.adminIds?.includes(teamId));
};
